import { memo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { AlertIcon } from 'src/assets/icons/Alert';
import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { CHANNEL, getChannelPerformanceLabel } from 'src/data/channel';

import { useStyles } from './useStyles';

export const AuthErrorMessage = memo(({ className, classes, channel, onConnectToChannel }) => {
  const styles = useStyles({ classes });

  const channelLabel = getChannelPerformanceLabel(channel);

  return (
    <div className={cx(className, styles.root)}>
      <CustomTypography
        className={styles.message}
        variant={TYPOGRAPHY_VARIANT.regular14}
      >
        <AlertIcon className={styles.icon} />
        Your {channelLabel} connection has expired.{' '}
      </CustomTypography>
      <ButtonText onClick={() => onConnectToChannel(channel)}>Reconnect {channelLabel}</ButtonText>
    </div>
  );
});

AuthErrorMessage.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  channel: PropTypes.oneOf(Object.values(CHANNEL)).isRequired,
  onConnectToChannel: PropTypes.func.isRequired,
};

AuthErrorMessage.defaultProps = {
  className: null,
  classes: null,
};
